export function register(config) {
  if ("serviceWorker" in navigator) {
    const swUrl = `${process.env.REACT_APP_URL}/service-worker.js`;

    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          if (config && config.onUpdate) {
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) return;
              installingWorker.onstatechange = () => {
                if (installingWorker.state === "installed") {
                  if (navigator.serviceWorker.controller) {
                    config.onUpdate(registration);
                  } else {
                    if (config.onSuccess) {
                      config.onSuccess(registration);
                    }
                  }
                }
              };
            };
          }
        })
        .catch((error) => {
          console.error("Error during service worker registration:", error);
        });
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
